import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b3121ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "profile",
  class: "profile-box"
}
const _hoisted_2 = { class: "left-container" }
const _hoisted_3 = {
  class: "map-img animate__animated animate__backInLeft wow",
  alt: ""
}
const _hoisted_4 = { class: "right-container" }
const _hoisted_5 = {
  "data-wow-duration": "1s",
  class: "techtitle animate__animated animate__backInDown wow"
}
const _hoisted_6 = { class: "techcontext" }
const _hoisted_7 = { class: "span animate__animated animate__fadeInUp wow" }
const _hoisted_8 = {
  "data-wow-duration": "2s",
  class: "circles animate__animated animate__fadeInUp wow"
}
const _hoisted_9 = { class: "circle" }
const _hoisted_10 = { class: "num" }
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { class: "circle" }
const _hoisted_13 = { class: "num" }
const _hoisted_14 = { class: "text" }
const _hoisted_15 = { class: "circle" }
const _hoisted_16 = { class: "num" }
const _hoisted_17 = { class: "text" }

import WOW from 'wowjs'
import { onMounted, ref } from "vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'ComProfile',
  setup(__props) {

const number1 = ref(30)
const number2 = ref(6000)
const number3 = ref(0)
const number4 = ref(4)

document.addEventListener('DOMContentLoaded', function () {
  const circlesElement = document.querySelector('.circles')
  const eventTriggered = false

  function checkIfInView() {
    const elementRect = circlesElement.getBoundingClientRect()
    const elementInView = (elementRect.top >= 40 && elementRect.bottom <= window.innerHeight)

    if (elementInView && !eventTriggered) {
      // 在元素可视区域内且事件未被触发时执行事件
      // console.log('开始计数')

      const interval = setInterval(() => {
        // 数字递增到目标值
        number1.value = Math.min(number1.value + 30 / 10, 30)
        number2.value = Math.min(number2.value + 6000 / 10, 3000)
        // number3.value = Math.min(number3.value + 30 / 10, 30)
        number4.value = Math.min(number4.value + 4 / 4, 4)
        // 到达目标值后停止定时器

        if (number1.value === 6000 && number2.value === 30 && number4.value === 4) {
          clearInterval(interval)
        }
      }, 100)
    }
  }

  // 监听滚动事件
  window.addEventListener('scroll', checkIfInView)
})

onMounted(() => {
  new WOW.WOW(
    { live: false }
  ).init()

})


return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
        [_directive_lazy, require('@/assets/map.png')]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('RekeyMed')), 1),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('rekeymed')), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('subprofile')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('profilecontent')), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(number1.value) + "+ ", 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('Intellectual Property')), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(number2.value) + "+m² ", 1),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('R&D laboratory')), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(number4.value) + "+ ", 1),
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('Study')), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})